import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';

// Composants
import { BaseComponent } from 'src/app/@shared/components/abstract/base.component';

// Modèles
import { Client } from 'src/app/@shared/models/client/client.model';
import { Divider } from "primeng/divider";

@Component({
    selector: 'app-organization-card',
    imports: [
        CommonModule,
        AvatarModule,
        ButtonModule,
        TagModule,
        TooltipModule,
        Divider
    ],
    templateUrl: './organization-card.component.html',
    styleUrls: ['./organization-card.component.scss']
})
export class OrganizationCardComponent extends BaseComponent {

    /*----------------------------------------------------------------------------------------
     * Gestion de la vue
     ----------------------------------------------------------------------------------------*/

    @Input()
    public accountantMode: boolean = false;

    @Output() activationClicked = new EventEmitter<Client>();
    @Output() organizationClicked = new EventEmitter<Client>();

    /*----------------------------------------------------------------------------------------
     * Données
     ----------------------------------------------------------------------------------------*/

    private _client!: Client;
    public get client(): Client | undefined {
        return this._client;
    }
    @Input()
    public set client(client: Client) {
        this._client = client;
    }

    /*----------------------------------------------------------------------------------------
     * Accesseurs
     ----------------------------------------------------------------------------------------*/

    /*----------------------------------------------------------------------------------------
     * Méthodes publiques
     ----------------------------------------------------------------------------------------*/

    public getPackageLabel(pkg: string): string {
        switch (pkg) {
            case this.Packages.Free:
                return 'Limité';
            case this.Packages.Premium:
                return 'Activé';
            default:
                return 'Onboarding';
        }
    }

    public onClickActivate(): void {
        this.activationClicked.emit(this.client);
    }

    public onClickCard(): void {
        if (!this.accountantMode) {
            this.organizationClicked.emit(this.client);
        }
    }

    public onClickSelect(): void {
        this.organizationClicked.emit(this.client);
    }

    /*----------------------------------------------------------------------------------------
     * Méthodes privées
     ----------------------------------------------------------------------------------------*/

}
